import { render, staticRenderFns } from "./QuickProjectCreator.vue?vue&type=template&id=2537c47c&scoped=true&"
import script from "./QuickProjectCreator.vue?vue&type=script&lang=ts&"
export * from "./QuickProjectCreator.vue?vue&type=script&lang=ts&"
import style0 from "./QuickProjectCreator.vue?vue&type=style&index=0&id=2537c47c&prod&lang=scss&"
import style1 from "./QuickProjectCreator.vue?vue&type=style&index=1&id=2537c47c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2537c47c",
  null
  
)

export default component.exports